export const TEST_IDS = {
  templateList: 'template-list',
  issueCreatedLink: 'issue-created-link',
  issueCreatedAnnouncement: 'issue-created-announcement',
}
